<dx-scroll-view data-testid="suspense-scroll-view">
  <form #formElement (submit)="onSubmit($event)">
    <dx-form data-testid="form" id="form" class="cards-wide"
    [formData]="suspenseData"
    [showValidationSummary]="true"

    validationGroup="formGroup"
    >
     <dxi-item itemType="group" cssClass="dx-widget" [colCount]="1" labelMode="static">

        <dxi-item labelMode="static" dataField="requestType" editorType="dxSelectBox" cssClass="dx-widget"
          [editorOptions]="{ items: requestTypes, valueExpr: 'name', displayExpr: 'name',
                required: 'true', searchMode: 'contains', searchEnabled: true, onSelectionChanged: onRequestTypeSelectionChanged, onOpened: onRequestTypeDropdownOpened }">
          <dxo-label text="Request Type"> </dxo-label>
          <dxi-validation-rule type="required" message="Request Type is required">
          </dxi-validation-rule>
        </dxi-item>

         <dxi-item itemType="group" [colCount]="4">
        <dxi-item
            labelMode="static"
            dataField="loanNumber"
            editorType="dxSelectBox"
            [colSpan]="3"
            [editorOptions]="{ items: loanData, valueExpr: 'name', displayExpr: 'name',
                    required: 'true' , searchMode: 'contains', searchEnabled: true, itemTemplate: loanItemTemplate}"
          >
          <dxo-label text="Loan Number"> </dxo-label>
          <dxi-validation-rule
          type="required"
          message="Loan Number is required">
        </dxi-validation-rule>
        </dxi-item>

         <dxi-item
          editorType="dxCheckBox"
          [label]="{ visible: false}"
          cssClass="loan-checkbox-center-align"
          [editorOptions]="{ text: activeLoanCheckboxText , onValueChanged: onShowInactiveLoansChanged, value: false}"
        >
        </dxi-item>
    </dxi-item>
        <dxi-item labelMode="static" dataField="currency" editorType="dxSelectBox" cssClass="dx-widget"
          [editorOptions]="currencyEditorOptions">
          <dxo-label text="Currency"> </dxo-label>
          <dxi-validation-rule type="required" message="Currency is required">
          </dxi-validation-rule>
        </dxi-item>

        <dxi-item
            labelMode="static"
            dataField="amount"
            editorType="dxNumberBox"
            [editorOptions]="amountEditorOptions"
          >
          <dxo-label text="Amount"> </dxo-label>
          <dxi-validation-rule
          type="required"
          message="Amount must be greater than zero"
          [validationCallback]="onValidateAmount"
          [reevaluate]="true"/>
        </dxi-item>
         <dxi-item labelMode="static" dataField="description" editorType="dxTextArea"
          [editorOptions]="{ height: 100, required: 'true' }">
          <dxo-label text="Description"> </dxo-label>
          <dxi-validation-rule type="required" message="Description is required">
          </dxi-validation-rule>
        </dxi-item>

        <dxi-item horizontalAlignment="center">
          <app-file-upload labelText="" selectButtonText="Browse or drop files here"
            [existingFileUrls]="isEditable ? (task?.parentUrls ?? []) : []"
            (onFileUploadEventEmitter)="onFileUpload($event)"
            (onFileRemoveEventEmitter)="onFileRemove($event)"/>
        </dxi-item>

          <dxi-item  cssClass="borrow-submit" horizontalAlignment="center" editorType="dxButton"
          [editorOptions]="{  text: 'Submit', useSubmitBehavior: true}"></dxi-item>
      </dxi-item>
    </dx-form>
  </form>
    <dx-load-panel data-testid="suspense-load-panel" container=".cards-wide" [position]="{ of: '.content' }" [visible]="isLoading"
      [showPane]="true"></dx-load-panel>
</dx-scroll-view>
